import { render, staticRenderFns } from "./PlatformUsers.vue?vue&type=template&id=60f84992&scoped=true"
import script from "./PlatformUsers.vue?vue&type=script&lang=js"
export * from "./PlatformUsers.vue?vue&type=script&lang=js"
import style0 from "./PlatformUsers.vue?vue&type=style&index=0&id=60f84992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f84992",
  null
  
)

export default component.exports